import React from 'react'

interface HistoricoMChatPerguntaSectionProps {
  children: React.ReactNode
}

export const HistoricoMChatPerguntaSection = (props: Readonly<HistoricoMChatPerguntaSectionProps>) => {
  const { children } = props

  return (
    <div data-historico-nested-section>
      {React.Children.toArray(children).map((child) => (
        <div key={getNestedLineKey(child)} data-historico-nested-line>
          {child}
        </div>
      ))}
    </div>
  )
}

const getNestedLineKey = (child: React.ReactNode): React.Key => {
  if (React.isValidElement(child) && child.key !== null) return child.key
  if (typeof child === 'string' || typeof child === 'number') return child
  return 'nested-line'
}
